import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { editBackground } from '../../actions/contact';
import { makeStyles, Link, Icon } from '@material-ui/core';

const initialState = {
  background: ''
};

const Background = ({ contact, editBackground }) => {
  const useStyles = makeStyles(theme => ({
    root: {
      margin: '1em 0 1em 0',
      background: '#F2F4F4',
      color: '#333',
      height: 'auto'
    },
    headingDiv: {
      display: 'flex',
      background: '#D5D8DC'
    },
    head: {
      padding: '5px'
    },
    editIcon: { paddingTop: '5px' },
    bgbody: { padding: '5px' }
  }));

  const classes = useStyles();

  const [clicked, setClicked] = useState(false);

  const onClick = e => {
    e.preventDefault();
    setClicked(true);
  };

  const onClickCancel = e => {
    e.preventDefault();
    setClicked(false);
  };

  const [formData, setFormData] = useState(initialState);

  const { background } = formData;

  const onChangeInput = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    editBackground(formData, contact._id);
    setClicked(false);
  };

  useEffect(() => {
    if (contact) {
      const bcData = { ...initialState };
      for (const key in contact) {
        if (key in bcData) bcData[key] = contact[key];
      }
      setFormData(bcData);
    }
  }, [contact]);

  return (
    <Fragment>
      {clicked ? (
        <Fragment>
          <div className={classes.root}>
            <div className={classes.headingDiv}>
              <div>
                <h4 className={classes.head}>
                  <i class='fas fa-user'></i> Background
                </h4>
              </div>
              <div className={classes.editIcon}>
                <Icon
                  className='fas fa-pen'
                  style={{ color: '#333', fontSize: 15 }}
                  onClick={e => onClick(e)}
                ></Icon>
              </div>
            </div>
            <form className='bc-form' onSubmit={e => onSubmit(e)}>
              <div className='form-group'>
                <textarea
                  name='background'
                  cols='30'
                  rows='3'
                  placeholder='Background'
                  value={background}
                  onChange={e => onChangeInput(e)}
                  required
                />
              </div>
              <input type='submit' className='btn btn-firm' value='Save' />
              <Link href='#' onClick={e => onClickCancel(e)}>
                Cancel
              </Link>
            </form>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className={classes.root}>
            <div className={classes.headingDiv}>
              <div>
                <h4 className={classes.head}>
                  <i class='fas fa-user'></i> Background
                </h4>
              </div>
              <div className={classes.editIcon}>
                <Icon
                  className='fas fa-pen'
                  style={{ color: '#333', fontSize: 15 }}
                  onClick={e => onClick(e)}
                ></Icon>
              </div>
            </div>
            <p className={classes.bgbody}>{contact.background}</p>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

Background.propTypes = {
  contact: PropTypes.object.isRequired,
  editBackground: PropTypes.func.isRequired
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, { editBackground })(Background);



// WEBPACK FOOTER //
// ./src/components/contact/Background.js